<template>
    <div class="vx-col md:w-full sm:w-auto">
        <div class="vx-row md:w-full">
            <vx-tooltip class="position-icon" :text="$t('button.offOn')" póition="top">
                <vs-switch v-model="onOff" vs-icon-off="close" vs-icon-on="done" class="mt-3"></vs-switch>
            </vx-tooltip>

            <vx-tooltip class="position-icon" :text="$t('button.edit')" position="top">
                <feather-icon icon="EditIcon" class="action-success icon-btn"
                              svgClasses="h-5 w-5 hover:text-primary cursor-pointer"
                              @click="editRecord"/>
            </vx-tooltip>

            <vx-tooltip class="position-icon" :text="$t('button.delete')" position="top">
                <feather-icon icon="TrashIcon" class="action-err icon-btn"
                              svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
                              @click="confirmDeleteRecord"/>
            </vx-tooltip>
        </div>
    </div>
</template>

<script>

import {isAPI, isRouter} from "../../../../store/permission"
import {constAPI, constRouter} from "../../../../store/constant"

export default {
    name: 'CellRendererActions',
    data() {
        return {
            status: true
        }
    },
    created() {
        this.status = this.params.data.enabled
    },
    computed: {
        onOff: {
            get() {
                return this.status
            },
            set() {
                this.turnOnOff(!this.status)
            }
        }
    },
    methods: {
        isPermissionDelete() {
            return isAPI(this, constAPI.employee_delete)
        },
        turnOnOff(enabled) {
            this.params.data.enabled = enabled
            let formData = new FormData(), config = {};
            config = {
                headers: {
                    "Content-Type": "multipart/form-data"
                },
            };
            const blob = new Blob([JSON.stringify(this.params.data)], {type: 'application/json'});
            formData.append('dto', blob);
            this.$vs.loading()
            this.$crm.post(`/employee/update/${this.params.data.id}`, formData, config).then(() => {
                this.status = enabled
                this.$vs.notify({
                    color: 'success',
                    text: 'Cập nhật thành công',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                })
                this.$store.commit('UPDATE_EMPLOYEE', true);
                this.$vs.loading.close()
            }).catch(err => {
                this.params.data.enabled = !enabled
                this.$vs.loading.close()
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-icon-alert-circle',
                    color: 'danger'
                })
            })
        },
        editRecord() {
            this.$router.push(`/user/edit-employee?branch_id=${this.params.data.organizationBranchId}&id=${this.params.data.employeeId}`).catch(() => {
            })
        },
        confirmDeleteRecord() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận xoá`,
                text: `Bạn có chắc là muốn xoá nhân viên "${this.params.data.fullName}" không ?`,
                accept: this.deleteRecord,
                acceptText: "Xoá",
                cancelText: "Huỷ"
            })
        },
        deleteRecord() {
            this.$vs.loading();
            this.$crm.post('/employee/delete/' + this.params.data.employeeId).then(() => {
                this.$vs.loading.close();
                this.showDeleteSuccess();
                this.$store.commit('UPDATE_EMPLOYEE', true);
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        showDeleteSuccess() {
            this.$vs.notify({
                color: 'success',
                text: 'Xoá thành công',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
            })
        }
    }
}
</script>

<style scoped>

</style>

